export enum AlertIconName {
  ERROR = 'cancel',
  INFO = 'info',
  SUCCESS = 'check_circle',
  WARN = 'warning',
}
